import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "click-menu"
};
const _hoisted_2 = {
  class: "flex justify-between px-4 py-2"
};
const _hoisted_3 = {
  key: 0,
  class: "menu"
};
const _hoisted_4 = {
  class: "bg-white shadow-xl rounded absolute px-2 py-3 w-52 z-10 action-menu custom-border border at-action-menu"
};
const _hoisted_5 = {
  class: "cursor-pointer flex"
};
const _hoisted_6 = {
  style: {
    "margin": "1px"
  }
};
import draggable from 'vuedraggable';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import EventTracker from '@/services/eventTracker';
export default {
  __name: 'TableFields',
  props: {
    updatePdfState: {
      type: Object,
      required: true
    },
    showSortableModel: {
      type: Boolean,
      default: false
    },
    tracking: {
      type: Object,
      required: false
    },
    isTrainingFlow: {
      type: Boolean,
      default: false
    },
    groupingEnabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggleConfigureFields'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const {
      handleError
    } = useSnackbarHandler();
    const toggleTableFieldsList = fields => {
      if (!fields.isEnabled) {
        props.updatePdfState.disabledTableFields.push({
          displayName: fields.displayName,
          fieldName: fields.fieldName,
          invoiceTemplateTableFieldId: fields.invoiceTemplateTableFieldId,
          isEnabled: false
        });
        props.updatePdfState.tableFields = props.updatePdfState.tableFields.filter(field => field.invoiceTemplateTableFieldId !== fields.invoiceTemplateTableFieldId);
      } else {
        if (props.updatePdfState.tableFields.length >= 8) {
          fields.isEnabled = false;
          handleError('You can only select up to 8 fields');
          return;
        }
        props.updatePdfState.tableFields.push({
          order: props.updatePdfState.tableFields.length + 1,
          invoiceTemplateTableFieldId: fields.invoiceTemplateTableFieldId,
          displayName: fields.displayName,
          fieldName: fields.fieldName,
          isEnabled: true
        });
        props.updatePdfState.disabledTableFields = props.updatePdfState.disabledTableFields.filter(field => field.invoiceTemplateTableFieldId !== fields.invoiceTemplateTableFieldId);
      }

      // Track column enable/disable event
      if (props.tracking) {
        EventTracker.trackEvent(props.tracking, 'Invoice Template', 'Columns Modified', {
          sourceContext: props.isTrainingFlow ? 'trainingFlow' : 'invoiceSettings'
        });
      }
    };
    const onMove = () => {};
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[8] || (_cache[8] = _createElementVNode("hr", {
        style: {
          "margin": "4px"
        }
      }, null, -1)), _createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "text-base pt-1"
      }, "Table Fields", -1)), _createVNode(LlSecondaryButton, {
        variant: "flat",
        "prepend-icon": __props.groupingEnabled ? 'mdi-lock-outline' : 'mdi-filter-variant',
        disabled: __props.groupingEnabled,
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('toggleConfigureFields'))
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" Columns ", -1)]))]),
        _: 1
      }, 8, ["prepend-icon", "disabled"])]), __props.showSortableModel && !__props.groupingEnabled ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_unref(draggable), {
        modelValue: __props.updatePdfState.tableFields,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => __props.updatePdfState.tableFields = $event),
        group: "people",
        onStart: _cache[2] || (_cache[2] = $event => _ctx.drag = true),
        onEnd: _cache[3] || (_cache[3] = $event => _ctx.drag = false),
        move: onMove,
        "item-key": "fieldName"
      }, {
        item: _withCtx(({
          element
        }) => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_v_icon, {
          class: "pt-1.5"
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("mdi-drag", -1)]))]),
          _: 1
        }), _createVNode(LlCheckbox, {
          modelValue: element.isEnabled,
          "onUpdate:modelValue": $event => element.isEnabled = $event,
          label: element.displayName,
          onCheckboxClick: $event => toggleTableFieldsList(element)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onCheckboxClick"])])]),
        _: 1
      }, 8, ["modelValue"]), _withDirectives(_createElementVNode("hr", _hoisted_6, null, 512), [[_vShow, __props.updatePdfState?.disabledTableFields?.length]]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.updatePdfState.disabledTableFields, (fields, idx) => {
        return _openBlock(), _createElementBlock("div", {
          key: idx,
          class: "flex felx-row"
        }, [_cache[7] || (_cache[7] = _createElementVNode("span", {
          class: "px-2.5"
        }, null, -1)), _createVNode(LlCheckbox, {
          modelValue: fields.isEnabled,
          "onUpdate:modelValue": $event => fields.isEnabled = $event,
          label: fields.displayName,
          onCheckboxClick: $event => toggleTableFieldsList(fields)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onCheckboxClick"])]);
      }), 128))])])])) : _createCommentVNode("", true)]);
    };
  }
};